"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgTasks(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M2.809 17.34a2.808 2.808 0 110 5.616 2.808 2.808 0 010-5.616zm0 1.532a1.276 1.276 0 10-.002 2.552 1.276 1.276 0 00.002-2.552zm20.425.511a.766.766 0 01.104 1.525l-.104.007H8.936a.766.766 0 01-.104-1.525l.104-.007h14.298zM2.809 9.17a2.808 2.808 0 110 5.616 2.808 2.808 0 010-5.616zm0 1.532a1.276 1.276 0 10-.002 2.552 1.276 1.276 0 00.002-2.552zm20.425.51a.766.766 0 01.104 1.526l-.104.007H8.936a.766.766 0 01-.104-1.525l.104-.007h14.298zM6.432 1.243c.263.282.273.708.04 1l-.077.083L3.118 5.39a.766.766 0 01-.916.098l-.093-.065L.28 3.92a.766.766 0 01.88-1.25l.092.065 1.31 1.076 2.787-2.606a.766.766 0 011.083.037zm16.802 1.8a.766.766 0 01.104 1.525l-.104.007H8.936a.766.766 0 01-.104-1.524l.104-.007h14.298z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgTasks;
exports.default = _default;